import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import Drawer from "component/MarketPlace/Drawer";
import { StyledButton } from "./VirtualDeviceDetail.style";

export interface IVirtualDeviceDetail {
  open: boolean;
  onClose: () => void;
  handleOpenKBLink: () => void;
  handleReleaseVirtualDevice: () => void;
  locale?: any;
  virtualData: any;
  loadingRelease: boolean;
  holderName?: string;
  isOpenSubmenu?: boolean;
  handleWidgetIndex?: (arg: boolean) => void;
}
const NOT_AVAILABLE = 'N/A';

const VirtualDeviceDetail = (props: IVirtualDeviceDetail) => {
  const { open, onClose, handleOpenKBLink, handleReleaseVirtualDevice, virtualData, holderName, locale, loadingRelease, isOpenSubmenu, handleWidgetIndex } = props;
  return (
    <Drawer open={open} onClose={onClose} isOpenSubmenu={isOpenSubmenu} handleWidgetIndex={handleWidgetIndex}>
      <Card
        sx={{
          padding: "24px",
          height: "100%",
          border: "none",
          display: "flex",
          flexDirection:"column",
        }}
        variant="outlined"
      >
        <Box maxHeight="100dvh" height="100%" overflow="scroll">
          <CardMedia
            component="img"
            image={virtualData?.icon}
            alt="Virtual Device Image"
            title="Virtual Device Image"
            sx={{ objectFit: "contain", maxHeight: "140px" }}
          />
          <CardHeader
            sx={{ paddingTop: "30px" }}
            title={
              <Box>
                <Typography variant="overline" color="text.secondary">
                  {locale?.virtualDesktop?.toUpperCase()}
                </Typography>
                <Typography variant="h5" color="text.primary">
                  {virtualData?.name}
                </Typography>
              </Box>
            }
          />
          <CardContent>

            <Grid container sx={{ paddingTop: "12px" }} xs={12}>
              <Grid item xs={4}>
                <Box sx={{ width: "150px" }} display="flex" alignItems="center">
                  <Typography
                    fontWeight={700}
                    fontSize="12px"
                    color="text.secondary"
                  >
                    {(locale?.description as string)?.toUpperCase()}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Box>
                  <Typography
                    fontWeight={400}
                    fontSize="12px"
                    color="text.secondary"
                  >
                    {virtualData?.description || NOT_AVAILABLE}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {holderName && (
              <Grid container sx={{ paddingTop: "12px" }} xs={12}>
                <Grid item xs={4}>
                  <Box sx={{ width: "150px" }} display="flex" alignItems="center">
                    <Typography
                      variant="overline"
                      alignSelf="center"
                      color="text.secondary"
                    >
                      {(locale?.assignedTo as string)?.toUpperCase()}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={8}>
                  <Box>
                    <Typography
                      alignSelf="center"
                      variant="body1"
                      color="text.secondary"
                      fontWeight={400}
                      fontSize="14px"
                    >
                      {holderName}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            )}
          </CardContent>
        </Box>
        <CardActions
          disableSpacing
          sx={{
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <StyledButton
            fullWidth
            color="primary"
            variant="outlined"
            disabled={loadingRelease}
            startIcon={loadingRelease && <CircularProgress size={14} />}
            onClick={handleReleaseVirtualDevice}
            id="btn-virtualdevicedetail-release"
          >
            {locale?.releaseVirtualDesktop}
          </StyledButton>
          <StyledButton
            onClick={handleOpenKBLink}
            fullWidth
            color="primary"
            variant="outlined"
            id="btn-virtualdevicedetail-openkb"
          >
            {locale?.useVirtualDesktop}
          </StyledButton>
        </CardActions>
      </Card>
    </Drawer>
  );
};

export default VirtualDeviceDetail;
